const STORAGE_KEY = "frd_password_reset_flow_v1";

export type PasswordResetSession = {
  email: string;
  isFromPasswordReset: true;
};

export function setPasswordResetSession(data: PasswordResetSession): void {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  } catch {
    // private mode or quota
  }
}

export function getPasswordResetSession(): PasswordResetSession | null {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as PasswordResetSession;
    if (
      parsed &&
      typeof parsed.email === "string" &&
      parsed.isFromPasswordReset === true
    ) {
      return { email: parsed.email, isFromPasswordReset: true };
    }
    return null;
  } catch {
    return null;
  }
}

export function clearPasswordResetSession(): void {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
}
